import { FeedbackContainerProps } from "../feedback/with-feedback";
import Feedback from "../feedback/feedback-container";

export interface ShowFeedbackProps
  extends Pick<FeedbackContainerProps, "onHideFeedback" | "feedback"> {
  idPrefix: string;
}
export default function ShowFeedback(props: ShowFeedbackProps) {
  const { feedback, idPrefix, onHideFeedback } = props;
  return (
    <>
      {feedback &&
        feedback.map((f) => {
          return (
            <Feedback
              key={idPrefix + f.id}
              id={idPrefix + f.id}
              type={f.type}
              show={true}
              onClose={() => {
                onHideFeedback(f.id);
              }}
              autoClose={f.autoclose === true}
              dangerouslySetInnerHTML={{ __html: f.msg }}
            />
          );
        })}
    </>
  );
}
